import * as React from 'react'
import { styled } from 'styled-components'

const Container = styled.div`
  width: 100%;
  height: 4px;

  @media screen and (min-width: 768px) {
    height: 8px;
  }

  margin: 1rem 0;

  background: rgba(247, 251, 253, 0.4); /* $body-bg-color */
  border-radius: 3px;
  overflow: hidden;
`

const Progress = styled.div<{ $width: number }>`
  width: ${props => props.$width || 0}%;
  height: 100%;

  background: var(--bs-body-bg);

  transition: all 0.3s ease-in-out;
`

interface ProgressBarProps {
  current: number
  total: number
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  const width = Math.max((current / total) * 100, 0)
  return (
    <Container>
      <Progress $width={width} />
    </Container>
  )
}
